import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 59;

export const migration_58_59:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.surface )
        {
            const viewportLayoutProp:any = Object.values(designState.surface.props)
                .find((prop:any) => prop.name === 'viewportLayout');

            viewportLayoutProp._value.desktopOrientation = {
                '__type': 'STRINGENUM',
                'selectedValue': 'Horizontal',
                'values': [
                    'Horizontal',
                    'Vertical'
                ]
            };

            viewportLayoutProp._value.tabletOrientation = {
                '__type': 'STRINGENUM',
                'selectedValue': 'Horizontal',
                'values': [
                    'Horizontal',
                    'Vertical'
                ]
            };

            viewportLayoutProp._value.mobileOrientation = {
                '__type': 'STRINGENUM',
                'selectedValue': 'Vertical',
                'values': [
                    'Horizontal',
                    'Vertical'
                ]
            };

            viewportLayoutProp._value.customSizeOrientation = viewportLayoutProp._value.deviceOrientation;

            delete viewportLayoutProp._value.deviceOrientation;
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};
